import React, { useContext, useEffect, useState } from "react";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import List from "./ProjectFloorTable";
import Pagination from "../Pagination";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import { Link } from "react-router-dom";

function ProjectFloorManager() {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const manager =
    user?.permission?.find((e) => e.manager === "project_floors_manager") ?? {};
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [filterData, setFilterData] = useState({
    isReset: false,
    searchKey: "",
  });
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [sort, setSort] = useState({
    sortKey: "createdAt",
    sortType: "desc",
  });

  const { status, searchKey } = filterData;

  const fetchProjects = async (data) => {
    try {
      const payload = {
        page,
        pageSize,
        keyword: searchKey ? searchKey.trim() : null,
        sortKey: sort.sortKey,
        sortType: sort.sortType,
      };
      const path = apiPath.projectFloors;
      const result = await apiGet(path, payload);
      const response = result?.data?.results;
      const resultStatus = result?.data?.success;
      setList(response?.docs);
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null,
      });
    } catch (error) {
      console.log("error in get all users list==>>>>", error.message);
    }
  };
  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  const handleChange = (event) => {
    setFilterData({
      ...filterData,
      isFilter: true,
      // searchKey:event.target.value,
      [event.target.name]: event.target.value,
    });

    setPage(1);
  };

  const handleReset = () => {
    setFilterData({
      endDate: "",
      isReset: true,
      isFilter: false,
      searchKey: "",
    });
    setPage(1);
  };

  useEffect(() => {
    fetchProjects();
  }, [page, sort, status, searchKey]);

  return (
    <div>
      <div className="bg-white">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] ">
            <form className="border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3">
              <div className="2xl:ml-auto xl:ml-0 lg:pt-0 pt-2">
                <label
                  htmlFor="default-search"
                  className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
                >
                  {t("O_SEARCH_BY_TITLE")}
                </label>
                <div className="flex">
                  <div className="relative ">
                    <div className="absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none">
                      <svg
                        aria-hidden="true"
                        className="w-4 h-4 text-[#A5A5A5] dark:text-gray-40"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {!filterData?.searchKey && (
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          />
                        )}
                      </svg>
                    </div>
                    <input
                      type="search"
                      id="default-search"
                      name="searchKey"
                      title=""
                      className="block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[300px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder={t("O_SEARCH_BY_TITLE")}
                      value={searchKey}
                      required
                      onChange={(e) => handleChange(e)}
                    />
                  </div>

                  {(manager?.add || user?.role === "admin") && (
                    <Link
                      title={t("O_ADD_PROJECT_FLOOR")}
                      to="/project-floors/add-project-floor"
                      className="bg-[#8FC150] flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap"
                    >
                      + {t("O_ADD_PROJECT_FLOOR")}
                    </Link>
                  )}
                </div>
              </div>
            </form>
            <List
              page={page}
              sort={sort}
              setSort={setSort}
              list={list}
              fetchProjects={fetchProjects}
              manager={manager}
              paginationObj={paginationObj}
            />
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectFloorManager;
